import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';
import { applyTheme } from './theme.ts';
import { initNative } from './native.ts';
import { getState, openConversation, openFromUrl } from './store.ts';

applyTheme();

// Phone app (Capacitor): back button / swipe and notification taps. No-op in a browser.
void initNative({
  back: () => {
    const dialog = document.querySelector('dialog[open]');
    if (dialog) {
      dialog.dispatchEvent(new Event('cancel', { cancelable: true }));
      return true;
    }
    const lightbox = document.querySelector<HTMLElement>('.lightbox');
    if (lightbox) {
      lightbox.click();
      return true;
    }
    if (document.querySelector('.info-panel')) {
      window.dispatchEvent(new Event('tc-close-info'));
      return true;
    }
    if (getState().activeId) {
      void openConversation(null);
      return true;
    }
    return false;
  },
  openUrl: openFromUrl,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
